<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">데일리 라이팅 관리</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card mt-20">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th style="width: 5%">No</th>
                        <th style="width: 5%">발송날짜</th>
                        <th style="width: 5%">작성날짜</th>
                        <th>해석</th>
                        <th>스크립트</th>
                        <th style="width: 5%">사용유무</th>
                      </tr>
                      <tr v-for="(item,index) in dws" :key="item.idx">
                        <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                        <td>{{ (item.ndate !== "") ? $moment(item.ndate).format('YYYY-MM-DD') : '' }}</td>
                        <td>{{ (item.createdate !== null) ? $moment(item.createdate).format('YYYY-MM-DD') : '' }}</td>
                        <td><!--<a :href="'/productModify/' + item.idx">-->{{ item.q1Kor }}</td>
                        <td>{{ item.q1Eng }}</td>
                        <td>{{ item.isUse }}</td>
                      </tr>
                      <tr v-if="lastpage === 0">
                        <td colspan="6">데일리 라이팅이 존재하지 않습니다.</td>
                      </tr>
                    </table>

                    <div style="padding-left:40%; padding-top:20px;">
                      <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                                :click-handler="clickCallback" :prev-text="'Prev'"
                                :next-text="'Next'" :container-class="'pagination'"
                                :page-class="'page-link'">
                      </paginate>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/inc_menu.vue'
import Paginate from 'vuejs-paginate';

export default {
  name: 'product',
  components: {
    Paginate,
    Menu,
  },
  props: {
    msg: String
  },
  data: () => ({
    filter: {
      page: 1
    },
    dws: [],
    lastpage: 1

  }),
  mounted() {
    this.initPage();
  },
  methods: {
    clickCallback: function (pageNum) {
      // console.log(pageNum)
      this.filter.page = pageNum;
      this.initPage();
    },
    initPage: function () {
      this.getMerchants(this.filter.page);
    },

    getMerchants: function (page) {
      const url = this.$store.state.host + "/v1/admin/dw";

      var params = {
        page: page
      }

      this.axios.get(url, {
        params
      })
      .then((res) => {
        if (res.data.status === 105) {
          this.dws = [];
          this.lastpage = 0;
        } else {
          this.result = res.data.result;
          this.dws = res.data.result.value;
          this.lastpage = res.data.result.lastPage;
        }
      });
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

</style>
